import styled from '@emotion/styled';

const CaptchaContainer = styled.div`
  .grecaptcha-badge {
    width: 300px !important;
    right: 0px !important;
  }

  iframe {
    width: 100%;
  }
`;

export default CaptchaContainer;
